import React, { useState } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Grid, Typography } from '@mui/material';
import ConfirmModal from '../../modals/confirmx'; // Modal reutilizável
import { importClients, createClient } from '../../../services/api'; // Funções de API

const CriarCliente = () => {
    // Estado para o formulário de criação do cliente
    const [clientData, setClientData] = useState({
        name: '',
        nome2: '',
        ncont: '',
        email: '',
        phone: '',
        fax: '',
        contacto: '',
        address: '',
        morada: '',
        local: '',
        codpost: '',
        zona: '',
        obs: ''
    });

    // Estados para controle das modais
    const [confirmImportVisible, setConfirmImportVisible] = useState(false);
    const [confirmCreateVisible, setConfirmCreateVisible] = useState(false);

    // Atualiza os dados do formulário e loga o novo payload
    const handleChange = (e) => {
        const newData = { ...clientData, [e.target.name]: e.target.value };
        setClientData(newData);
        
    };

    // Chama a API para importar os clientes do PHC e loga o resultado
    const handleImportAPI = async () => {
        try {
            const response = await importClients();
            console.log('Clientes importados:', response.data.imported);
        } catch (error) {
            console.error('Erro ao importar clientes:', error);
        }
    };

    // Processa a criação do cliente e loga o payload
    const handleCreateClient = async () => {
        console.log('Criando cliente com os dados:', clientData);
        try {
            const response = await createClient(clientData);
            console.log('Cliente criado:', response.data);
        } catch (error) {
            console.error('Erro ao criar cliente:', error);
        }
    };

    // Validação simples do email usando regex
    const isValidEmail = (email) => {
        // Expressão regular básica para validar email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    // Handlers para a modal de importação
    const handleImport = () => {
        setConfirmImportVisible(true);
    };

    const onConfirmImport = () => {
        setConfirmImportVisible(false);
        handleImportAPI();
    };

    const onCancelImport = () => {
        setConfirmImportVisible(false);
    };

    // Handlers para a modal de criação
    const handleConfirmCreate = () => {
        setConfirmCreateVisible(true);
    };

    const onConfirmCreate = () => {
        // Valida se o email é válido antes de prosseguir
        if (!isValidEmail(clientData.email)) {
            alert('Por favor, insira um email válido.');
            return;
        }
        setConfirmCreateVisible(false);
        handleCreateClient();
    };

    const onCancelCreate = () => {
        setConfirmCreateVisible(false);
    };

    // Cabeçalho do Card com botão de Importação no canto superior direito
    const header = (
        <div style={{ position: 'relative' }}>
            <h2>Criar Cliente</h2>
            <Button 
                label="Importar Clientes do PHC" 
                icon="pi pi-upload" 
                className="p-button-primary"
                onClick={handleImport}
                style={{ position: 'absolute', top: 0, right: 0 }}
            />
        </div>
    );

    return (
        <Card header={header}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <div className="p-field">
                        <label htmlFor="name">Nome</label>
                        <InputText 
                            id="name" 
                            name="name" 
                            value={clientData.name} 
                            onChange={handleChange} 
                            style={{ width: '100%' }} 
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className="p-field">
                        <label htmlFor="nome2">Abreviatura</label>
                        <InputText 
                            id="nome2" 
                            name="nome2" 
                            value={clientData.nome2} 
                            onChange={handleChange} 
                            style={{ width: '100%' }} 
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className="p-field">
                        <label htmlFor="ncont">Número de Contribuinte</label>
                        <InputText 
                            id="ncont" 
                            name="ncont" 
                            value={clientData.ncont} 
                            onChange={handleChange} 
                            style={{ width: '100%' }} 
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className="p-field">
                        <label htmlFor="email">Email</label>
                        <InputText 
                            id="email" 
                            name="email" 
                            value={clientData.email} 
                            onChange={handleChange} 
                            style={{ width: '100%' }} 
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className="p-field">
                        <label htmlFor="phone">Telefone/Telemóvel</label>
                        <InputText 
                            id="phone" 
                            name="phone" 
                            value={clientData.phone} 
                            onChange={handleChange} 
                            style={{ width: '100%' }} 
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className="p-field">
                        <label htmlFor="fax">Fax</label>
                        <InputText 
                            id="fax" 
                            name="fax" 
                            value={clientData.fax} 
                            onChange={handleChange} 
                            style={{ width: '100%' }} 
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className="p-field">
                        <label htmlFor="contacto">Contacto</label>
                        <InputText 
                            id="contacto" 
                            name="contacto" 
                            value={clientData.contacto} 
                            onChange={handleChange} 
                            style={{ width: '100%' }} 
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className="p-field">
                        <label htmlFor="address">Address</label>
                        <InputText 
                            id="address" 
                            name="address" 
                            value={clientData.address} 
                            onChange={handleChange} 
                            style={{ width: '100%' }} 
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className="p-field">
                        <label htmlFor="morada">Morada</label>
                        <InputText 
                            id="morada" 
                            name="morada" 
                            value={clientData.morada} 
                            onChange={handleChange} 
                            style={{ width: '100%' }} 
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className="p-field">
                        <label htmlFor="local">Local</label>
                        <InputText 
                            id="local" 
                            name="local" 
                            value={clientData.local} 
                            onChange={handleChange} 
                            style={{ width: '100%' }} 
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className="p-field">
                        <label htmlFor="codpost">Código Postal</label>
                        <InputText 
                            id="codpost" 
                            name="codpost" 
                            value={clientData.codpost} 
                            onChange={handleChange} 
                            style={{ width: '100%' }} 
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className="p-field">
                        <label htmlFor="zona">Zona</label>
                        <InputText 
                            id="zona" 
                            name="zona" 
                            value={clientData.zona} 
                            onChange={handleChange} 
                            style={{ width: '100%' }} 
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div className="p-field">
                        <label htmlFor="obs">Observações</label>
                        <InputText 
                            id="obs" 
                            name="obs" 
                            value={clientData.obs} 
                            onChange={handleChange} 
                            style={{ width: '100%' }} 
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <Button 
                        label="Confirmar Criação" 
                        icon="pi pi-check" 
                        className="p-button-success" 
                        onClick={handleConfirmCreate}
                    />
                </Grid>
            </Grid>

            {/* Modal de Confirmação para Importar */}
            <ConfirmModal 
                visible={confirmImportVisible}
                message="Tem certeza que deseja importar os clientes do PHC?"
                onConfirm={onConfirmImport}
                onCancel={onCancelImport}
            />

            {/* Modal de Confirmação para Criação */}
            <ConfirmModal 
                visible={confirmCreateVisible}
                message="Deseja confirmar a criação deste cliente?"
                onConfirm={onConfirmCreate}
                onCancel={onCancelCreate}
            />
        </Card>
    );
};

export default CriarCliente;
